const es = {
  numberOfChargers: `Número de Cargadores`,
  numberOfChargingSessions: `Número de Sesiones de Carga`,
  numberOfUsers: `Número de Usuarios`,
  numberOfVehicles: `Número de Vehículos`,
  numberOfKWH: `Número de KW's`,
  chargingAmount: `Número de Sesiones de Carga`,
  chargeAmount: `Importe de los Cargos`,
  chargerStatus: `Estado del Cargador`,
  usersLogged: `Usuarios Conectados`,
  username: `Nombre de Usuario`,
  chargerProvider: `Proveedor del cargador`,
  password: `Contraseña`,
  passwordConfirm: `Confirmar contraseña`,
  updatePasword: `Actualizar Contraseña?`,
  id: `ID`,
  userGroupRequired: 'Se requiere un grupo de usuarios',
  rate: `Tarifa`,
  address1: `Dirección 1`,
  address2: `Dirección 2`,
  deleteAgent: `Eliminar Agente`,
  billingFrequencyRequired: `Se requiere la frecuencia de facturación`,
  billingFrequency: `Frecuencia de facturación`,
  group: `Grupo`,
  addCreditToGroup: `Agregar Crédito al Grupo:`,
  addCredit: `Agregar Crédito`,
  chargersWithoutLocation: `Cargadores sin ubicación`,
  provisioningDate: `Fecha de Provisión`,
  active: `Activo`,
  inactive: `Inactivo`,
  deleteProvider: `Está seguro de que desea eliminar el proveedor`,
  connector: `Conector`,
  editTariff: `Editar Tarifa`,
  createTariff: `Crear Tarifa`,
  maxCharge: `Máx. de Carga`,
  remove: 'Eliminar',
  addConnector: 'Agregar conector',
  maxVoltage: `Potencia Máxima`,
  loadebalanceLimit: `Tiempo de Carga`,
  serialNumberRequired: `Se requiere un número de serie`,
  deleteCharger: 'Está seguro de que desea eliminar el cargador',
  status: `Estado`,
  close: `Cerrar`,
  createButton: `Crear`,
  maxPower: `Potencia Máxima`,
  dataNotFound: `No se encontraron datos`,
  currency: `Moneda`,
  login: `Iniciar sesión`,
  userGroups: `Grupos de Usuarios`,
  logout: `Salir`,
  balance: `Balance`,

  chargingProfiles: 'Perfiles de Carga',
  addChargingProfile: 'Agregar Perfil de Carga',
  editChargingProfile: 'Editar Perfil de Carga',

  resultsNotFound: `No se encontraron resultados`,
  chargerPictures: `Fotos del Cargador`,

  welcome: 'Bienvenido a',
  seeliggExplain: 'Plataforma para la gestión de carga de coches eléctricos',
  signin: `Iniciar sesión en Seeligg Backoffice`,
  forgotPassword: `¿Olvidaste tu contraseña?`,
  rememberMe: `recuérdame`,
  insertDetails: `Insertar detalles a continuación`,
  email: `Correo electrónico`,
  name: `Nombre`,
  paymentType: `Tipo de Pago`,
  habilitarfaturacao: `Habilitar Facturación`,
  website: `Sitio Web`,
  surname: `Apellido`,
  firstname: `Nombre`,
  lastname: `Apellido`,
  phoneNumber: `Teléfono`,
  address: `Dirección`,
  image: `Imagen`,
  year: `Año`,
  of: `hacer`,
  deleteSelectedItems: 'Está seguro de que desea eliminar todos los elementos seleccionados?',

  commission: 'Comisión',
  addCreditToUser: `Añadir Creédito al usuario`,

  priceMinValue: `El valor mínimo es 0`,
  providerAccount: 'Origen de la cuenta',

  rejectSelectedConfirm: '¿Está segura de que desea rechazar los artículos seleccionados?',
  reject: 'Rechazar',
  rejectSelected: 'Rechazar fotos seleccionadas',

  deleteSelectedUsers: 'Está seguro de que desea eliminar los usuarios seleccionados?',
  deleteBrand: 'Estás seguro de que quieres eliminar a marca ',
  deleteVehicle: 'Estás seguro de que quieres eliminar o vehículo ',
  deleteOutlet: 'Está segura de que desea eliminar la salida del vehículo ',
  deleteModel: 'Estás seguro de que quieres eliminar o modelo ',

  postalCode: `Código Postal`,
  city: `Ciudad`,
  country: `País`,
  tariffs: 'Tarifas',
  tariff: 'Tarifa',
  deleteCharger: 'Está seguro de que desea eliminar el cargador',
  deleteProvider: 'Está seguro de que desea eliminar el proveedor',
  changeTariffPrice: `Cambiar Precio de Tarifa`,
  minWalletValue: `Mín. Valor de la Billetera`,
  openMultiSeccion: `Abrir Multisección`,
  postalCode: `Código Postal`,
  language: `Idioma`,
  description: `Descripción`,
  role: `Rol`,
  roles: `Roles`,
  user: `Usuario`,
  users: `Usuarios`,
  userProfile: `Perfil de usuario`,
  vehicle: `Vehículo`,
  vehicles: `Vehículos`,
  charger: `Cargador`,
  chargers: `Cargadores`,
  maxCharger: `Máx. de carga`,
  countryRequired: `Pais es obligatorio`,
  typeRequired: `Tipo es obligatorio`,
  amperes: 'Amps',
  maxAmps: `Máx. de Amperios`,
  maxVoltage: `Voltaje máximo de carga`,
  sucess: `Éxito`,
  sucessful: `con éxito.`,
  addedSucessful: `añadido con éxito.`,
  updatedSucessful: `actualizado con éxito.`,
  updatePassword: `Actualizar contraseña`,
  deletedSucessful: `eliminado con éxito.`,
  error: `Error`,
  errorOccured: `Ocurrió un error.`,
  errorOccuredTryAgain: `Ocurrió un error. Vuelve a intentarlo.`,
  errorOccuredTryAgainLater: `Ocurrió un error. Vuelva a intentarlo más tarde.`,
  vehiclesManagement: `Gestión de vehículos`,
  usersManagement: `Gestión de usuarios`,
  chargersManagement: `Gestión de cargadores`,
  chargersInformation: `Información de cargadores`,
  chargersAdminMode: `Modo administrador de cargadores`,
  providers: `Proveedores`,
  provider: `Proveedor`,
  addUser: `Crear Usuario`,
  addProvider: `Agregar proveedor`,
  addVehicle: `Agregar vehículo`,
  addCharger: `Agregar cargador`,
  addBrand: `Agregar marca`,
  addModel: `Agregar modelo`,
  addOutletType: `Agregar salida`,
  providerList: `Lista de proveedores`,
  providerGroups: `Grupos de proveedores`,
  providerGroup: 'Grupo',
  editChargerInformation: `Editar información de cargador`,
  chargerList: `Lista de cargadores`,
  chargerLogs: `Registro de cargadores`,
  vehicleList: `Lista de vehículos`,
  usersList: `Lista de Usuarios`,
  brandsList: `Lista de marcas`,
  modelsList: `Lista de modelos`,
  firmwareList: `Lista de firmware`,
  outletTypesList: `Lista de tiendas`,
  payments: `Pagos`,
  settings: `Configuración`,
  new: `Nuevo`,
  add: `Agregar`,
  edit: `Editar`,
  exportToExcel: `Exportar a Excel`,
  delete: `Eliminar`,
  generateQRCodes: `Generar códigos QR`,
  search: `Buscar`,
  searchHere: `Buscar aquí...`,
  save: `Guardar`,
  saveChanges: `Guardar cambios`,
  cancel: `Cancelar`,
  brand: `Marca`,
  brands: `Marcas`,
  model: `Modelo`,
  models: `Modelos`,
  outletType: `Salida`,
  outletTypes: `Puntos de venta`,
  outletTypesAssociated: `Tiendas asociadas a este modelo`,
  outletTypesAssociated: `Tiendas asociadas con este modelo`,
  editUser: `Editar Usuario`,
  editUserProfile: `Editar perfil de usuario`,
  editUserProfilePassword: `Editar contraseña de usuario`,
  editProvider: `Editar proveedor`,
  editVehicle: `Editar vehículo`,
  editCharger: `Editar cargador`,
  editBrand: `Editar marca`,
  editChargerInformation: `Editar información del cargador`,
  editModel: `Editar modelo`,
  chargerGroups: `Grupos de cargadores`,
  chargersWithoutProvisioning: `Cargadores sin provisión`,
  creditsManagement: `Gestión de creéditos`,
  editOutletType: `Editar salida`,
  editChargerLocation: `Editar ubicación del cargador`,
  deleteConfirmationA: `¿Estás seguro de que quieres eliminar esto`,
  deleteConfirmationB: `¿Estás seguro de que quieres eliminar esto`,

  deleteBrand: 'Estás seguro de que quieres eliminar a marca ',
  deleteVehicle: 'Estás seguro de que quieres eliminar o vehículo ',
  deleteOutlet: 'Está segura de que desea eliminar la salida del vehículo ',
  deleteModel: 'Estás seguro de que quieres eliminar o modelo ',

  createUser: `Crear nuevo usuario`,
  createVehicle: `Crear nuevo vehículo`,
  createCharger: `Crear nuevo cargador`,
  createBrand: `Crear nueva marca`,
  createModel: `Crear nuevo modelo`,
  createOutletType: `Crear nueva salida`,
  map: `Mapa`,
  amount: `Cantidad`,
  list: `Lista`,
  serialNumber: `Número de serie`,
  dataType: `Tipo de datos`,
  dateCreated: `Fecha de entrada`,
  dateChange: `Fecha de cambio`,
  entryDate: `Fecha de entrada`,
  endDate: `Fecha de finalización`,
  entryText: `Descripción del registro`,
  origin: `Origen`,
  type: `Tipo`,
  notificacions: `Notificaciones`,
  profile: `Perfil`,
  selected: `seleccionado`,
  tooltipTitle: `Seleccione de la tabla los cargadores que desea editar y luego presione este botón.`,
  chooseFile: `Elegir archivo`,
  noFile: `Ningún archivo seleccionado`,
  file: `Archivo`,
  selected: `seleccionado`,
  version: `Versión`,
  loadingSessions: `Sesión de carga`,
  createChargingSession: `Crear sesión de carga`,
  execute: `Ejecutar`,
  actionToPerfom: `¿Qué acción de carga desea realizar:`,
  terminate: `Terminar sesión`,
  create: `Iniciar sesión`,
  agents: `Agentes`,
  agents: `Agente`,
  agentsList: `Lista de agentes`,
  addAgent: `Agregar Agente`,
  editAgent: `Editar Agente`,
  newAgente: `Nuevo Agente`,
  updateFirmware: `Actualizar Firmware`,
  uploadFirmware: `Carregar Firmware`,
  firmware: `Firmware`,
  firmwares: `Firmwares`,
  fileName: `Nombre del archivo`,
  execute: `Ejecutar`,
  addressLine1: `Dirección 1`,
  addressLine2: `Dirección 2`,

  billingType: `Tipo de facturación`,
  minValue: `Valor minimo`,
  mangePaymentTypeChargers: `Aquí puede gestionar el tipo de pago de los cargadores seleccionados.`,

  addressPostalCode: `Código postal`,
  operationSusscessfuly: `Operação realizada com sucesso`,
  send: `Enviar`,
  groupes: `Grupos`,
  userRole: `Rol de usuario`,
  paymentsManagement: `Gestión de pagos`,
  payments: `Pagamentos`,
  payamentsList: `Lista de pagos`,
  paymentStatus: `Estado del pago`,
  paymentType: `Tipo de pago`,
  invoices: `Facturas`,
  invoicesList: `Lista de facturas`,
  invoiceFile: `Archivo de factura`,
  paymentLogs: `Registro de pagamentos`,
  paymentLogsList: `Lista de registros de pagos`,
  networks: `Redes`,
  updateNetwork: `Actualizar red`,
  chooseCharger: `Elegir cargador`,
  manageBillingMethod: `Gestionar método de facturación`,
  manageTaxFree: `Gestionar impuestos`,
  billingMethod: `Método de facturación`,
  price: `Precio`,
  cancel: `Cancelar`,
  delete: `Eliminar`,
  details: `Detalles`,
  publicAddress: `Dirección pública`,
  privateAddress: `Dirección privada`,
  macAddress: `Dirección MAC`,
  port: `Puerto`,
  gateway: `Puerta de enlace`,
  subnetMask: `Máscara de subred`,
  dns: `DNS`,
  wifiSSid: `Wifi SSID`,
  wifiPassword: `Contraseña Wifi`,
  privateIP: `IP privada`,
  publicIP: `IP pública`,
  private: `Privado?`,
  yes: `Si`,
  no: `No`,
  copyGroup: `Copiar grupo`,
  groupCopySucessful: `El grupo se ha copiado correctamente.`,

  public1: `Público`,
  private1: `Privado`,
  chargingReport: `Informes de carga`,
  chargingReports: `Informes de carga`,
  chargeReportsList: `Lista de informes de carga`,
  user_charger: `Usuario / Cargador`,
  userInfo: `Información del Usuario `,
  providerInformation: `Información del proveedor`,

  // ------------------REQUIRED DATA---------------------------
  chargerRequired: ` Se requiere un cargador`,
  vehicleRequired: `Se requiere un vehículo`,
  optionRequired: `Se requiere una opción`,

  firstnameRequired: `Se requiere un nombre`,
  lastnameRequired: `Se requiere un apellido`,
  passwordConfirmRequired: `Se requiere una contraseña de confirmación`,
  passwordMatch: `Las contraseñas deben coincidir`,
  minimunLength: `Se requiere al menos 8 caracteres`,

  chargementList: `Lista de cargamentos`,

  userNameRiquired: `Se requiere un nombre de usuario`,
  phoneRequired: `Se requiere un telefono`,
  emailRequired: `Se requiere un correo`,
  passwordRequired: `Se requiere una contraseña`,
  descriptionRequired: `Se requiere una descripción`,
  nameRequired: `Se requiere un nombre`,
  powerRequired: `Se requiere una potencia`,
  deleteTariff: `¿Estás seguro de que quieres eliminar tarifario?`,
  deleteGroup: `¿Estás seguro de que quieres eliminar grupo`,
  tariffList: `Lista de tarifarios`,
  removeFromGroup: `Remover del grupo`,
  addToGroup: `Agregar al grupo`,
  moeda: `Moneda`,
  minWalletValue: `Valor mín. Billetera`,
  faturation: `Facturación`,
  openFreeCharge: `Habilitar la carga gratuita`,
  freeCharge: `Carreg. Gratis`,
  sendCommand: `Enviar comando`,
  deleteCurrentCharger: `¿Está seguro de que desea eliminar este cargador?`,
  command: `Command`,
  nome: `Nombre `,
  addGroup: 'Agregar grupo',
  editGroup: 'Editar grupo',
  confKey: `Clave de configuración`,
  availability: `Disponibilidad`,
  message: `Mensaje`,
  tariffsManagement: `Gestión de tarifarios`,
  tariff: `Tarifario`,
  tariffs: `Tarifarios`,
  print: `Impresión`,
  fromGroup: `de este grupo?`,
  deleteAllGroupsMessage: `¿Estás seguro de que quieres eliminar todos los grupos?`,
  deleteProviders: '¿Está seguro de que desea eliminar todos estos proveedores?',
  creditsAmount: `Quantidade de créditos`,
  addCreditsToUser: `Anadir creéditos al usuario`,

  defineTariffPrice: `Establece el precio de cada tarifa`,
  tariffPrice: `El precio debe establecerse en su moneda local`,
  chargingUpTo: ` - carga de hasta`,
  providersGroups: `Grupos de proveedores`,
  chargersInformation: `Información del cargador`,

  chargerGrop: `Grupo del cargador`,
  chargerGropuAssociate: `Cargadores asociados a -`,
  searchEmailUsername: 'Buscar por correo o nombre de usuario',
  usersAssociateTo: `Usuarios asociados a -`,
  walletstransactions: `Transacciones de billetera`,
  deleteUser: `¿Estás seguro de que quieres eliminar usuario`,
  newTransaction: `Nueva transacción`,
  transactionsManagemant: `Gestión de transacciones`,
  credits: `Créditos`,
  observation: `Observacion`,
  operation: `Operación`,
  firmwareVersion: `Firmware Version`,
  deleteVehicleMessage: `¿Estás seguro/a de que quieres eliminar todos estos vehículos?`,
  ocppChargers: ' Cargadores Ocpp',
  ocppChargersList: ' Lista de cargadores Ocpp',
  sorryPageNotFound: `Lo sentimos, página no encontrada`,
  pageNotFoundTitle:
    'Lo sentimos, no encontramos la página que estás buscando. Quizás has equivocado la URL? Asegúrate de revisar tu ortografía.',
  goHome: 'Ir a inicio',
  title404: 'Página no encontrada',
  title500: '500 Error interno del servidor',
  tryLatter: 'Hubo un error, por favor inténtelo de nuevo más tarde.',
  transactions: `Transacciones`,
  currentPerPhase: `Corriente por fase`,
  availabilityWarning: `La hora de inicio de la disponibilidad del cargador debe ser menor que la hora de finalización de la disponibilidad del cargador!`,
  currencyRequired: `Se requiere una moneda`,
  connectorRequired: `Se requiere un conector`,
  taxeRequired: `Se requiere un impuesto`,
  counrtyRequired: `Se requiere un pais`,
  websiteRequied: `Se requiere un sitio web`,
  emailValide: `Debe ser un correo valido`,
  addressRequired: `Se requiere una dirección`,
  postalCodeRequired: `Se requiere un Código Postal`,
  paymentMethodRequired: `Se requiere un metodo de pago`,
  states: `Estados`,
  removeLocation: 'Remover ubicación',
  editLocation: 'Editar ubicación',
  back: 'Volver',
  next: `Siguiente`,
  evNotCharging: `EV no cargando`,
  roads: 'Carreteras',
  satellite: 'Satélite',
  verifyEmail: `Verificar Email`,
  addressLine: `Dirección`,
  verifyEmailTitle: `Verifica tu correo electronico para activar tu cuenta.`,

  noResultsFor: `No se han encontrado resultados para `,
  checkingKeywords: `. Intenta comprobar si hay errores tipográficos o usar palabras completas.`,
  pleaseEnterKeywords: `Por favor, introduzca las palabras clave`,

  addChargerGroup: 'Crear grupo de cargadores',
  editChargerGroup: 'Editar grupo de cargadores',

  hardwareRequired: `Se requiere un ID de hardware`,
  providerRequired: `Se requiere un proveedor`,

  deleteItemConfirmation: `¿Está seguro de que desea eliminar este elemento?`,

  removeConnectorConfirmation: `¿Está seguro de que desea quitar este conector?`,

  deleteGroupConfirmation: `¿Seguro que desea eliminar estes grupos?`,
  addProviderMessage: `Este cargador no tiene ningún proveedor asignado, primero debe asignar un proveedor para poder editar la ubicación`,
  // CHARGER STATES
  notConnected: `No conectado`,

  connected: `Conectado`,
  evCharging: `EV Cargando`,
  evConnected: `EV Conectado`,
  evNotConnected: `EV No conectado`,
  standby: `En espera`,

  dataNotFound: `Datos no encontrados`,

  chargeState: 'Estado de Carga',

  useLoadBalance: 'Usar LoadBalance',

  userChargeHistory: `Historial de carga del usuario`,

  addProviderFirst: `Primero debe agregar un proveedor`,

  generatePaymentLogsChart: `Generar gráfico de pagos`,

  changeProvider: `Cambiar proveedor`,
  changeWifiNetwork: `Cambiar red Wifi`,

  timeStart: 'Hora de Início',
  timeEnd: 'Hora de Término',
  totalEnergy: 'Energia Total',
  totalCost: 'Costo Total',

  duration: 'Duración',

  stateDescription: {
    notConnected: '\nO carregador está OFFLINE',
    evCharging: 'El cargador está ONLINE y con un vehículo cargando',
    evConnected: 'El cargador está ONLINE y con un vehículo conectado',
    evNotConnected: 'El cargador está ONLINE, pero sin vehículo conectado',
    standby: 'El cargador está ONLINE, aguardando configuracion',
    noHeart: 'El cargador está ONLINE, pero sin TIERRA',
  },

  newPassword: `Nueva contraseña`,
  confirmNewPassword: `Confirmar nueva contraseña`,
  currentPassword: `Contraseña actual`,
  validEmail: `Debe ser un correo valido`,

  state: 'Estado',

  chargements: 'Cargamentos',
  energy: 'Energia',

  addTax: 'Agregar Impuesto',
  editTax: 'Editar Impuesto',
  tax: 'Impuesto',
  taxes: 'Impuestos',
  taxesList: 'Lista de Impuestos',
  value: 'Valor',
  removeProfie: 'Eliminar Perfil de Carga',
  removeProfileConfirm: '¿Está seguro de que desea eliminar este perfil de carga?',
  stackLevelIteger: 'El nivel de pila debe ser un número entero',
  stackLevelrequired: 'Se requiere un nivel de pila',
  chargingProfileKindRequired: 'Se requiere un tipo de perfil de carga',
  chargingRateUnitRequired: 'Se requiere una unidad de tarifa de carga',
  durationMustBeIteger: 'La duración debe ser un número entero',
  SchedulePeriodrequired: 'Se requiere un período de horario',
  startPeriodRequired: 'Se requiere un horario de inicio',
  limitIsRequired: 'Se requiere un límite',
  addSchedulePeriod: 'Agregar Period',
  addProfile: 'Agregar Perfil',

  stackLevel: 'Nivel de pila',
  chargingProfilePurpose: 'Propósito del perfil',
  chargingProfileKind: 'Tipo de perfil de carga',
  recurrenceKind: 'Tipo de recurrencia',
  chargingRateUnit: 'Unidad de tasa de carga',	
  minChargingRate: 'Mín. Tasa de carga',
  duration: 'Duración',
  startPeriod: 'Período de inicio',
  limit: 'Límite',
  numberPhases: 'Número de fases',
  schedulePeriod: 'Schedule Period',
  validFrom: 'Válido desde',
  validTo: 'Válido para',
  startSchedule: 'Horario de inicio',
  company: 'Compañia',

  viewProviles: 'Ver Perfiles',

  chargerGroupRequired: 'Se requiere un grupo de cargadores',
  firmwareRequired: `Se requiere un firmware`,
  retrieveDateRequired: `Se requiere una fecha de recuperación`,


  chargingProfile: `Perfil de Carga`,
  chargingProfileRequired: `Se requiere un perfil de carga`,

  available: {
    from: 'Disponible desde',
    until: 'Disponible hasta',
  },

  deleteChargingProfiles: `¿Está seguro de que desea eliminar este perfil de carga?`,
  deleteChargingProfile: `Eliminar Perfil de Carga`,
  start_schedule: 'Horario de Inicio',

  valid: {
    from: 'Valido desde',
    until: 'Valido hasta',
  },

  acess: 'Acesso',
  glossary: 'Glossário',
  filters: 'Filters',

  update: `Actualizar `,
  upload: `Subir`,

  pictureUnapproved: `No aprobar, seleccione para aprobar`,

  currentPerPhaseRequired: `Se requiere una corriente por fase`,
  priceRequired: `Se requiere un precio`,

  manufacturer: 'Fabricante',
  firmware_version: 'Versión Firmware',
  location: 'Ubicación',
  updateChargerLocation: '¿Actualizar la ubicación del cargador?',

  hourly: 'Por hora',
  daily: 'Diariamente',
  weekly: 'Semanalmente',
  biweekly: 'Quincenal',
  monthly: 'Mensalmente',
  yearly: 'Anualmente',
  glossary: 'Glossário',
  filter: 'Filtro',
  multipleSessions: 'Sesiones múltiples',
  approveSelected: 'Aprobar seleccionados fotos',
  picturesSelected: ' imagen(es) seleccionada(s)',
  noPicturesSelected: 'Ninguna imagen seleccionada',
  approve: 'Aprobar',
  pictures: 'Fotos',
  disassociate: 'Desasociar',
  approveSelectedConfirm: '¿Está seguro de que desea aprobar las fotos seleccionadas?',
  removeRFID: 'Eliminar RFID',
  deleteRFIDMEssage: '¿Está seguro de que desea eliminar el RFID ',
  removeRFIDConfirmation: 'Está seguro de que desea eliminar RFID ',
  fromUser: ' del cliente ',
  rfiList: 'Lista de RFID',

  information: 'Información',
  network: 'Red',

  imageRequired: 'Imagen es requerida',

  associateUser: 'Asociar RFID(s) a Cliente',
  removeRFIDToUser: 'Eliminar RFID(s) del cliente',
  removeRFIDConfirm: '¿Eliminar RFID(s) de todos los clientes seleccionados?',

  search: {
    email: 'Buscar por email',
    username: 'Buscar por nombre de usuario',
    emailOrUsername: 'Buscar por email o nombre de usuario',
    button: 'Buscar',
  },

  commands: {
    start: 'Iniciar carga',
    stop: 'Finalizar carga',
    startDebugMode: 'Iniciar el modo de depuración',
    stopDebugMode: 'Finalizar el modo de depuración',
    foreChargeStop: 'Forzar el fin de la carga',
  },
};

export default es;
